import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TicketsTable from "./components/TicketsTable";
import TicketReader from "./components/TicketReader";
import AddTicket from "./components/AddTicket";
import "./global.css"; // Importar el CSS global

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<TicketsTable />} />
          <Route path="/lector" element={<TicketReader />} />
          <Route path="/ticket" element={<AddTicket />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
